import axios from 'axios';

export default axios.create({
  baseURL: process.env.GATSBY_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const apiMatrix = axios.create({
  baseURL: process.env.GATSBY_MATRIX_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const apiSlim = axios.create({
  baseURL: process.env.GATSBY_SLIM_URL,
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Basic ${process.env.GATSBY_SLIM_AUTH}`,
  },
});

export const apiFiancaAluguelBusinessRegistration = axios.create({
  baseURL: process.env.GATSBY_FIANCA_ALUGUEL_BUSINESS_REGISTRATION_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});
